import type { FC } from 'react'
import { useState } from 'react'

import ContactButton from '@/components/ContactButton'
import type { SectionName } from '@/lib/apollo/mutation/log-contact'

import type { SubjectDetails, AgentDetails } from './Sidebar'
import ContactSidebar from './Sidebar'

interface Props {
  customerId: string
  sectionName: SectionName
  applicantDetails: SubjectDetails
  refereeDetails?: SubjectDetails
  agentDetails: AgentDetails
  disabled?: boolean
}

const Contact: FC<Props> = ({
  customerId,
  sectionName,
  applicantDetails,
  refereeDetails,
  agentDetails,
  disabled = false,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  return (
    <>
      {isSidebarOpen && (
        <ContactSidebar
          agentDetails={agentDetails}
          applicantDetails={applicantDetails}
          sectionName={sectionName}
          refereeDetails={refereeDetails}
          customerId={customerId}
          onClose={() => setIsSidebarOpen(false)}
        />
      )}
      <ContactButton disabled={disabled} onClick={() => setIsSidebarOpen(true)} />
    </>
  )
}

export default Contact
